import { TAB_HEIGHT } from './constants';
import { ITabsData } from './types';

export const ScrollToProperSection = (tabsData: ITabsData) => {
  const scroll = (sectionID) => {
    const sections = [...tabsData.tabSectionsRef.$el.childNodes];
    const element = sections.find((item) => (item.getAttribute ? item.getAttribute('id') == sectionID : null));

    if (!element) return;

    const top = Math.round(element.getBoundingClientRect().top) + window.scrollY - TAB_HEIGHT;

    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  };

  return { scroll };
};
